import { API_URL } from '../api/client';

interface QueryLogProps {
   log_url: string;
}

const QueryLogLink = (props: QueryLogProps): React.JSX.Element => {
   return (
      <a href={`${API_URL}/${props.log_url}`} title="go to Query processing log" target="_blank">
         <button className="btn btn-primary btn-dl">&#128196;&nbsp;Log</button>
      </a>
   );
};

export default QueryLogLink;
